import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Mission from './components/Mission';
import Services from './components/Services';
import CTA from './components/CTA';

export default function HomePage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-white page-transition">
        <Navbar />
        <Hero />
        <Mission />
        <Services />
        <CTA />
        <Footer />
      </div>
    </Suspense>
  );
}
